import type { MultiReferenceConstraints } from '../../helper'
import type { MultiRefResourceMediaKind } from '../../types'

const IMAGE_EXTS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
  '.gif',
  '.bmp',
  '.heic',
  '.heif',
]

export function sniffKind(
  file: File,
  constraints: MultiReferenceConstraints,
): MultiRefResourceMediaKind | null {
  const lowerName = file.name.toLowerCase()
  const type = file.type.toLowerCase()

  if (type.startsWith('image/')) return 'image'
  if (
    constraints.videoMimes.includes(type) ||
    constraints.videoExts.some(ext => lowerName.endsWith(ext))
  ) {
    return 'video'
  }
  if (
    constraints.audioMimes.includes(type) ||
    constraints.audioExts.some(ext => lowerName.endsWith(ext))
  ) {
    return 'audio'
  }
  /** MIME-less fallback (Safari sometimes drops file.type): match image exts */
  if (!type && IMAGE_EXTS.some(ext => lowerName.endsWith(ext))) return 'image'
  return null
}

export function acceptAttribute(
  constraints: MultiReferenceConstraints,
): string {
  const parts = new Set<string>()
  parts.add('image/*')
  for (const mime of constraints.videoMimes) parts.add(mime)
  for (const ext of constraints.videoExts) parts.add(ext)
  for (const mime of constraints.audioMimes) parts.add(mime)
  for (const ext of constraints.audioExts) parts.add(ext)
  return Array.from(parts).join(',')
}

export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds) || seconds <= 0) return ''
  const total = Math.round(seconds)
  if (total <= 0) return ''
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

export function kindMaxOf(
  kind: MultiRefResourceMediaKind,
  constraints: MultiReferenceConstraints,
): number {
  if (kind === 'image') return constraints.maxImages
  if (kind === 'video') return constraints.maxVideos
  return constraints.maxAudios
}
